export const buildCustomerEditPayload = (form) => {
  const name = String(form?.name || "").trim();
  if (!name) {
    throw new Error("Il nome cliente è obbligatorio.");
  }

  const email = String(form?.email || "").trim();
  const phone = String(form?.phone || "").trim();
  return {
    name,
    email: email || null,
    phone: phone || null,
  };
};
